import { useState } from 'react';
import { Network, ZoomIn, ZoomOut, RotateCcw } from 'lucide-react';

// Funzione ricorsiva (non componente): evita problemi di build con JSX autoreferenziante
function renderNode(node, depth, key, onNodeSelect) {
  const cls = depth === 0
    ? 'inline-block rounded-xl border px-3 py-1.5 text-sm font-medium bg-brand text-white border-brand'
    : 'inline-block rounded-xl border px-3 py-1.5 text-sm font-medium bg-white text-slate-800 border-slate-300';
  const children = node.children || [];
  return (
    <li key={key}>
      <button type="button" className={`${cls} ${node.node_id ? 'cursor-pointer hover:ring-2 hover:ring-brand/25 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand' : 'cursor-default'}`}
        onClick={() => node.node_id && onNodeSelect?.(node)} data-testid={node.node_id ? `map-node-${node.node_id}` : undefined}>
        {node.label}
      </button>
      {children.length > 0 && (
        <ul className="mt-2 ml-4 space-y-2 border-l-2 border-slate-200 pl-4">
          {children.map(function mapChild(c, i) { return renderNode(c, depth + 1, `${key}-${i}`, onNodeSelect); })}
        </ul>
      )}
    </li>
  );
}

export default function ConceptMap({ data, testId, onNodeSelect }) {
  const [zoom, setZoom] = useState(1);
  if (!data || !data.root) return null;
  return (
    <div data-testid={testId} className="rounded-2xl border border-slate-200 bg-slate-50/70 overflow-hidden">
      <div className="flex flex-col items-stretch gap-2 border-b border-slate-200 bg-white px-4 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-3">
        <p className="flex min-w-0 items-start gap-2 text-xs font-semibold uppercase leading-5 tracking-[0.1em] text-slate-600 sm:items-center"><Network size={14} className="mt-0.5 shrink-0 sm:mt-0" /> <span>{data.title || 'Mappa concettuale'}</span></p>
        <div className="flex shrink-0 items-center justify-end gap-1 border-t border-slate-100 pt-2 sm:border-0 sm:pt-0" aria-label="Controlli zoom mappa">
          <button onClick={() => setZoom((z) => Math.max(.75, z - .25))} className="flex h-10 w-10 items-center justify-center rounded-lg hover:bg-slate-100" aria-label="Riduci zoom"><ZoomOut size={16}/></button>
          <span className="w-11 text-center text-xs font-semibold text-slate-500" aria-live="polite">{Math.round(zoom * 100)}%</span>
          <button onClick={() => setZoom((z) => Math.min(1.75, z + .25))} className="flex h-10 w-10 items-center justify-center rounded-lg hover:bg-slate-100" aria-label="Aumenta zoom"><ZoomIn size={16}/></button>
          <button onClick={() => setZoom(1)} className="flex h-10 w-10 items-center justify-center rounded-lg hover:bg-slate-100" aria-label="Ripristina zoom"><RotateCcw size={15}/></button>
        </div>
      </div>
      <div className="overflow-auto p-5 sm:p-6" style={{ maxHeight: '70vh' }}>
        <ul className="space-y-2 min-w-[240px] origin-top-left transition-transform" style={{ transform: `scale(${zoom})`, width: `${100 / zoom}%` }}>
          {renderNode(data.root, 0, 'root', onNodeSelect)}
        </ul>
      </div>
    </div>
  );
}
